import {submitAnswer} from "./submit-answer.js";
import {renderExplanation} from "./render-explanation.js";
import {nextQuestionButtonRenderer, resultButtonRenderer} from "./render-buttons.js";
document.querySelectorAll("form.quiz-form").forEach((formElement) => {
  const buttons = formElement.querySelectorAll(".quiz-form__answer-wrapper button");
  for (const button of buttons) {
    button.addEventListener("click", function(event) {
      const answerField = formElement.querySelector("input.quiz-form__field-answer");
      answerField.value = this.value;
    });
  }
  const renderNextQuestionButton = nextQuestionButtonRenderer(formElement);
  const renderResultButton = resultButtonRenderer(formElement);
  formElement.addEventListener("submit", (ev) => {
    ev.preventDefault();
    submitAnswer(formElement).then((res) => {
      renderExplanation(formElement, res);
      if (res.hasNext) {
        renderNextQuestionButton(res);
      } else {
        renderResultButton(res);
      }
    });
  });
});
